import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import { setLoading } from '../../../../@core/components/skelton/store';

export const getCompanySettings = createAsyncThunk('companySettingsSlice/getCompanySettings', async () => {
    try {
        let response = await axios.get('/company-setting', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const addCompanySettings = createAsyncThunk('companySettingsSlice/addCompanySettings', async (data, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.put('/company-setting', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        dispatch(getCompanySettings());
        toast.success(response?.data?.message);
        return Promise.resolve(response);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getOwnerAccess = createAsyncThunk('companySettingsSlice/getOwnerAccess', async (id, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('/owner-access/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const addOwnerAccess = createAsyncThunk('companySettingsSlice/addOwnerAccess', async (data) => {
    try {
        let response = await axios.post('/owner-access', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message);
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message.msg || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getLeadScoreSetting = createAsyncThunk('companySettingsSlice/getLeadScoreSetting', async (id, { dispatch }) => {
    try {
        let response = await axios.get('/tenant-lead-score', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const addLeadScoreSetting = createAsyncThunk('companySettingsSlice/addLeadScoreSetting', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/tenant-lead-score', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(getLeadScoreSetting());
        toast.success(response?.data?.message);
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

const companySettingsSlice = createSlice({
    name: 'companySettings',
    initialState: {
        companySettingData: [],
        customUserAccess: [],
        leadScoreSetting: []
    },
    reducers: {
        removeCustomUserAccess: (state) => {
            state.customUserAccess = [];
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getCompanySettings.fulfilled, (state, action) => {
            state.companySettingData = action.payload;
        });
        builder.addCase(getOwnerAccess.fulfilled, (state, action) => {
            state.customUserAccess = action.payload;
            return;
        });
        builder.addCase(getLeadScoreSetting.fulfilled, (state, action) => {
            state.leadScoreSetting = action.payload;
            return;
        });
    }
});
export const { removeCustomUserAccess } = companySettingsSlice.actions;
export default companySettingsSlice.reducer;
